module.exports = __webpack_public_path__ + "static/app2-5e39f09c1739515a490f15d1506cd565.png";